var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA11YmenuStathalfdonut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1854 3.06114C14.237 3.9552 15.0031 5.17487 15.3278 6.56429H13.6331C13.3695 5.73812 12.894 5.00658 12.2705 4.43359L13.1854 3.06114ZM12.5929 8.06419H12.3654C12.3654 6.17008 10.8299 4.6346 8.93581 4.6346C7.0417 4.6346 5.50622 6.17008 5.50622 8.06419H5.27857V8.06429H2.37143H1.62143H0.871429C0.871429 3.6105 4.48193 0 8.93571 0C13.3895 0 17 3.6105 17 8.06429H16.25H15.5H12.5929V8.06419ZM8.93571 1.5C5.82644 1.5 3.22206 3.66176 2.54359 6.56429H4.23855C4.87317 4.57516 6.73626 3.1346 8.93581 3.1346C9.68258 3.1346 10.3906 3.30065 11.0249 3.59784L11.9394 2.22599C11.0393 1.76198 10.0181 1.5 8.93571 1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA11YmenuStathalfdonut);
export default __webpack_public_path__ + "static/media/a11ymenu_stathalfdonut.2202bc55a7a6e0714a5a94cabefc2731.svg";
export { ForwardRef as ReactComponent };